import _ from 'lodash';
import {
    FETCH_MTOKNA_MANUAL_INVOICES,
    CLEAN_MTOKNA_MANUAL_INVOICES,
    PAID_MTOKNA_MANUAL_INVOICE,
    CHANGE_MTOKNA_MANUAL_INVOICE_SETTINGS,
} from '../actions/types';
import {toNumber} from "../functions";

const MTOKNA_MANUAL_INVOICES_DEFAULT_STATE = {};

const MtoknaManualInvoicesReducer = (state = MTOKNA_MANUAL_INVOICES_DEFAULT_STATE, { type, payload }) => {
    switch (type) {
        case FETCH_MTOKNA_MANUAL_INVOICES:
            return payload;

        case CLEAN_MTOKNA_MANUAL_INVOICES:
            return MTOKNA_MANUAL_INVOICES_DEFAULT_STATE;

        case PAID_MTOKNA_MANUAL_INVOICE:
            return { ...state, items: _.map(state.items, item => {
                if (_.has(payload, item.id)) {
                    item = !_.isEmpty(payload[item.id])
                        ? { ...item, data: { ...item.data, state: payload[item.id], paid: true } }
                        : item;

                    item = { ...item, _matchingData: { ...item._matchingData, Invoices: { ...item._matchingData.Invoices, status: 'paid' } } };
                }

                return item;
            }) };

        case CHANGE_MTOKNA_MANUAL_INVOICE_SETTINGS:
            return { ...state, items: _.map(state.items, item => {
                    if (toNumber(item.id) === toNumber(payload.id)) {
                        item = { ...item, _matchingData: { ...item._matchingData, MtoknaManualFilters: { ...item._matchingData.MtoknaManualFilters, ...payload.settings } } };
                    }

                    return item;
                }) };

        default:
            return state;
    }
};

export default MtoknaManualInvoicesReducer;
